<template>
  <section>
    <preview-job-comments
      :comments="commentHighlights"
      :is-show="isShowComment"
      class="pega-comment-bar-inner"
      v-on="$listeners"
    />
    <div
      v-if="isShowTextCount"
      class="pega-count-moji-area inner"
    >
      <preview-text-count
        name="1日の仕事の流れタイトル"
        :count-target="timeScheduleTitle"
      />
      <preview-text-count
        v-for="(timeSchedule, i) in timeSchedules"
        :key="'count-' + i"
        class="mb1"
        :name="'1日の仕事の流れ' + (i + 1)"
        :count-target="{ value: timeSchedule.note, max: timeSchedule.max }"
      />
    </div>
    <h5>
      <span>1日の仕事の流れ</span>
    </h5>
    <p
      :id="id"
      class="flow_title"
      data-test="time-schedule-title"
    >
      {{ timeScheduleTitle.value }}
    </p>
    <div class="flow">
      <template
        v-for="(timeSchedule, i) in timeSchedules"
      >
        <p
          :id="id + '-' + $options.filters.zeroPadding(i + 1)"
          :key="i"
          :data-test="`time-schedule-${i + 1}`"
        >
          {{ timeSchedule.hour | zeroPadding }}：{{ timeSchedule.minute | zeroPadding }} {{ timeSchedule.note }}
        </p>
      </template>
    </div>
  </section>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/base" as *;
</style>

<script>
import PreviewJobComments from '@/components/molecules/PreviewJobComments'
import PreviewTextCount from '@/components/atoms/PreviewTextCount'
import jobPreviewCommon from '@/lib/jobPreviewCommon'
export default {
  components: {
    PreviewJobComments,
    PreviewTextCount
  },
  filters: {
    zeroPadding: (value) => {
      return value.toString().padStart(2, '0')
    }
  },
  mixins: [jobPreviewCommon],
  props: {
    id: {
      type: String,
      required: true
    },
    timeScheduleTitle: {
      type: Object,
      required: true
    },
    timeSchedules: {
      type: Array,
      required: true
    },
    max: {
      type: Number,
      default: 0
    },
    commentHighlights: {
      type: Array,
      default: () => []
    },
    isShowComment: {
      type: Boolean,
      required: true
    },
    isShowTextCount: {
      type: Boolean,
      required: true
    }
  },
  mounted () {
    this.commentHighlights.forEach((commentHighlight) => {
      this.setHighlight(commentHighlight)
    })
  }
}
</script>
